import InnerComponent from '@Components/Purchase/PurchaseOrders/ViewBulkPO';
import orgContainer from '@Components/AppContainer';

const ViewBulkPO = () => ((orgContainer(InnerComponent)));
export default ViewBulkPO;
